import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import { StoreStatsForm, StoreStatsResult } from 'components/StoreStats';
import { LoadingBar } from 'components/Commons';

import * as cm_action from 'actions/commons';
import * as usg_action from 'actions/usage';
import toastr from 'helpers/toastr';
import cm from 'helpers/commons';

class StoreStats extends Component {
  constructor() {
    super();

    this.state = {
      type: null
    };
  }

  componentWillMount() {
    cm.propsInit(this.props);
    //가맹점 목록
    this.storeSearch();
    //가맹점 통계 목록
    this.storeStatList();
  }

  componentDidMount() {
    cm.mainTitle('제휴식당 통계');
  }

  //가맹점
  storeSearch = async () => {
    try {
      const { cmAPI } = this.props;
      const params = '/?';

      await cmAPI.storeList(params);
    } catch (e) {
      console.log('##### storeSearch : ', e);
    }
  };

  submitForm = async (e) => {
    e.preventDefault();
    const { dateCheck } = this.props;

    if (!dateCheck.isValue.isState) {
      toastr('top-right', 'warning', dateCheck.isValue.message);
      return;
    }

    this.storeStatList();
  };

  storeStatList = () => {
    const { type } = this.state,
      { date, dateType, store, usageAPI } = this.props,
      params = {
        startdate: date
          ? date.sDate
          : moment()
              .startOf('month')
              .format('LLL'),
        enddate: date ? date.eDate : moment().format('LLL'),
        datetype: dateType ? dateType.value : 'MM',
        storeid: store ? store.value : null
      };

    usageAPI.storeStatList(params);

    this.setState({ type: dateType ? dateType.value : 'MM' });

    const { cmAPI } = this.props;
    cmAPI.changeExcel({
      excel: params
    });
  };

  render() {
    const { type } = this.state,
      { dateType, date, store, storeStats } = this.props,
      formFn = {
        submitForm: this.submitForm
      },
      resultFn = {
        type: type
      };

    let loading = '';
    if (!(dateType && date && store && storeStats)) {
      loading = <LoadingBar />;
    }
    return (
      <main className="ss">
        {loading}

        <StoreStatsForm formFn={formFn} />
        <StoreStatsResult resultFn={resultFn} />
      </main>
    );
  }
}

StoreStats = connect(
  (state) => ({
    dateType: state.commons.dateType,
    date: state.commons.date,
    dateCheck: state.commons.dateCheck,
    store: state.commons.store,
    storeStats: state.usage.storeStats
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        storeList: cm_action.StoreList,
        changeExcel: cm_action.ChangeExcel
      },
      dispatch
    ),

    usageAPI: bindActionCreators(
      {
        storeStatList: usg_action.StoreStatsList
      },
      dispatch
    )
  })
)(StoreStats);

export default StoreStats;
